import { render, staticRenderFns } from "./MasterTransferAccountDialog.vue?vue&type=template&id=58ab52d3&scoped=true&"
import script from "./MasterTransferAccountDialog.vue?vue&type=script&lang=js&"
export * from "./MasterTransferAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterTransferAccountDialog.vue?vue&type=style&index=0&id=58ab52d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab52d3",
  null
  
)

export default component.exports